import { InjectionToken } from '@angular/core';
import { Checklist, DomainEntityType } from '@models';
import { DataCollectionService } from '@store';
import { NgrxDataProviderHelper } from './ngrx-data-provider.helper';

export const CHECKLIST_COLLECTION_SERVICE = new InjectionToken(
  'CHECKLIST_COLLECTION_SERVICE',
  {
    factory: (): DataCollectionService<Checklist> =>
      NgrxDataProviderHelper.registerDefaultProvider(
        DomainEntityType.Checklist
      ),
  }
);
